import type { CalendarGridColDef, CalendarGridValueGetterFunc } from '../../CalendarGrid.model';

export type Value = string | null | undefined;

export const valueGetter: CalendarGridValueGetterFunc<Value> = ({ data }) => {
  return data?.symbol ?? data?.issuer?.primarySymbol ?? null;
};

const symbolColDef: CalendarGridColDef<Value> = {
  colId: 'symbol',
  headerName: 'Symbol',
  width: 104,
  type: 'text',
  filter: 'agTextColumnFilter',
  valueGetter,
};

export default symbolColDef;
